module.exports = __webpack_public_path__ + "img/More.ec82fb03.png";